export const BACKDROP_CLICK = 'backdropClick';
export const MOUSE_SCROLL = 'scroll';
export const WINDOW_NEW_TAB = '_blank';
export const WINDOW_RESIZE = 'resize';